import React from 'react'

const Feature_Area_Start = () => {
  return (
    <div>
      
      <section class="features-area pt-100 pb-45 rel z-1">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-6">
                        <div class="features-content-part mb-55" data-aos="fade-left" data-aos-duration="1500" data-aos-offset="50">
                            <div class="section-title mb-60">
                                <h2 className='work'>The Ultimate Travel Experience Features That Set Our Agency Apart</h2>
                            </div>
                            <div class="features-customer-box">
                                <div class="image">
                                    <img src="https://images.pexels.com/photos/1051075/pexels-photo-1051075.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Features"/>
                                </div>
                                <div class="content">
                                    <div class="feature-authors mb-15">
                                        <img src="assets/images/features/feature-author1.jpg" alt="Author"/>
                                        <img src="assets/images/features/feature-author2.jpg" alt="Author"/>
                                        <img src="assets/images/features/feature-author3.jpg" alt="Author"/>
                                        <span>4k+</span>
                                    </div>
                                    <h6>850K+ Happy Customer</h6>
                                    <div class="divider style-two counter-text-wrap my-25"><span><span class="count-text plus" data-speed="3000" data-stop="25">0</span> Years</span></div>
                                    <p>We pride ourselves offering personalized itineraries</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6" data-aos="fade-right" data-aos-duration="1500" data-aos-offset="50">
                        <div class="row pb-25">
                            <div class="col-md-6">
                                <div class="feature-item">
                                    <div class="icon"><i class="flaticon-tent"></i></div>
                                    <div class="content">
                                        <h5><a href="/">Tent Camping</a></h5>
                                        <p>Tent camping is wonderful way to connect with nature</p>
                                    </div>
                                </div>
                                <div class="feature-item">
                                    <div class="icon"><i class="flaticon-tent"></i></div>
                                    <div class="content">
                                        <h5><a href="/">Kayaking</a></h5>
                                        <p>Kayaking is a thrilling outdoor activity that adventure</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="feature-item mt-20">
                                    <div class="icon"><i class="flaticon-tent"></i></div>
                                    <div class="content">
                                        <h5><a href="/">Mountain Biking</a></h5>
                                        <p>Mountain biking is exhilarating sport that physical fitness</p>
                                    </div>
                                </div>
                                <div class="feature-item">
                                    <div class="icon"><i class="flaticon-tent"></i></div>
                                    <div class="content">
                                        <h5><a href="/">Fishing & Boat</a></h5>
                                        <p>Fishing and boat bring joy quintessential activities that</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Feature_Area_Start
